import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Modal, Button, Label} from 'semantic-ui-react';
import {buildParameters} from '../../../utils';
import {Actions} from '../../../../common/actions';
import {getUrlParameters} from '../../../../common/util/urlParameters';
import {downloadFile} from '../../../../common/util/file';
import PdfIcon from '../../../../partInvoices/components/icons/PdfIcon';
import Excelcon from '../../../../partInvoices/components/icons/Excelcon';

const {generateWarrantyReportFile} = Actions;

const GenerateFileModal = ({
  loading,
  disable,
  state,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const dispatch = useDispatch();

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const handleDowloadDocument = (e, {className}) => {
    const params = buildParameters(state);
    const fileType = className;
    if (fileType === 'pdf') {
      const baseUrl = process.env.REP_API_URL;
      const fileUrl = `${baseUrl}/warranties/report/${fileType}${getUrlParameters(
        params
      )}`;
      downloadFile(fileUrl);
    } else {
      dispatch(generateWarrantyReportFile(fileType, params));
    }
    closeModal();
  };

  return (
    <Modal
      onOpen={openModal}
      onClose={closeModal}
      open={modalIsOpen}
      closeIcon
      size='tiny'
      className='warranty-report-modal'
      trigger={
        <Button primary disabled={loading || disable}>
          Generar Reporte
        </Button>
      }
    >
      <Modal.Header>Reporte de garantías</Modal.Header>
      <Modal.Content>
        <h4>Seleccione el tipo de archivo:</h4>
        <div className='icons'>
          <Label as='a' className='pdf' onClick={handleDowloadDocument}>
            <PdfIcon />
            Archivo PDF
          </Label>
          <Label as='a' className='excel' onClick={handleDowloadDocument}>
            <Excelcon />
            Archivo Excel
          </Label>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default GenerateFileModal;
